<template>
    <div class="is-block px-4 py-4 pb-6 mb-6 has-scroll-y" style="overflow-x:hidden;">
        <div class="participants-zone pt-4" v-if="canAddUsers">
            <label v-t="'users_with_access'" class="label primary-font has-text-black"></label>
            <project-configuration-people :default-permission="project.defaultPermission"
                :shared-with.sync="project.sharedWith" @resendInvitation="resendInvitation" />
        </div>
        <div class="participants-zone pt-4" v-else>
            <label v-t="'users_with_access'" class="label primary-font has-text-eduloc-grey"></label>
            <project-configuration-people :default-permission="project.defaultPermission"
                :shared-with.sync="project.sharedWith" :disabled="true" />
        </div>
        <div class="pt-4" v-if="isProject">
            <div class="pb-2">
           
                <div class="columns is-mobile pt-2 mb-0 pr-0">
                    <div class="column is-narrow">
                        <span class="icon is-medium is-clickable" @click="changePrivacy('secret')">
                            <i class="mdi mdi-36px"
                                :class="project.privacy == 'secret' ? 'mdi-checkbox-marked-outline has-text-primary' : 'mdi-checkbox-blank-outline has-text-black'" />
                        </span>
                    </div>
                    <div class="columns is-mobile is-multiline  pt-3 mb-0 mr-0">
                        <div class="column pb-0">
                            <p class="check-title is-size-6 primary-font has-text-black">
                                <!--{{ $t('projectConfiguration.privacy_secret') }}-->
                                {{ $t('publish_on_web_and_app') }}
                            </p>
                            <p class="check-subtitle is-size-7 secondary-font has-text-black">
                                {{ $t('projectConfiguration.privacy_secret_description') }}</p>
                        </div>
                        <!--<div class="column is-narrow pl-2 pb-0" v-if="canAddAnonymous">
                            <div class="project-permissions">
                                <div class="select pt-1" :class="{ 'disabled': !isSecret }">
                                    <select @change="setProjectPermissionsSecret" class="member-permissions"
                                        :disabled="!isSecret" :class="{ 'disabled': !isSecret }">
                                        <option v-for="permission in permissionOptions" :key="permission"
                                            :value="permission" :selected="projectPerm == permission">
                                            {{
                                                $t(
                                                    `permission_${permission}`
                                                )
                                            }}
                                        </option>
                                    </select>
                                </div>
                            </div>
                        </div>

                        <div class="column is-narrow pl-2 pb-0" v-else-if="!canAddAnonymous && !canAddUsers">
                            <div class="project-permissions" @mouseenter="showPrivacyMessage" @mouseleave="hidePrivacyMessage" @click="togglePrivacyMessage">
                                <div class="select pt-1 disabled">
                                    <select disabled class="member-permissions disabled">
                                        <option v-for="permission in permissionOptions" :key="permission"
                                            :value="permission" :selected="projectPerm == permission">
                                            {{
                                                $t(
                                                    `permission_${permission}`
                                                )
                                            }}
                                        </option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div class="column is-narrow pl-2 pb-0" v-else-if="!canAddAnonymous && canAddUsers">
                            <div class="project-permissions" v-if="canAddUsers">
                                <div class="select pt-1" :class="{ 'disabled': !isSecret}">
                                    <select @change="setProjectPermissionsSecret" class="member-permissions"
                                        :disabled="!isSecret" :class="{ 'disabled': !isSecret }">
                                        <option v-for="permission in permissionLimitedOptions" :key="permission"
                                            :value="permission" :selected="projectPerm == permission">
                                            {{
                                                $t(
                                                    `permission_${permission}`
                                                )
                                            }}
                                        </option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div class="column is-12 pl-3 pt-1" :class="{ 'hidden': !isSecret }" >
                            <p class="is-size-7 has-text-eduloc-red secondary-font">{{
                                $t(`project_description_level_${projectPerm}`) }}</p>
                        </div>-->
                    </div>
                </div>
                <!--<div class="columns is-mobile pt-2 mb-0 pr-0" v-if="isProject && project.privacy == 'secret'">
                    <div class="column is-narrow">
                        <span class="icon is-medium is-clickable" @click="setAllUsersPermision()">
                            <i class="mdi mdi-36px"
                                :class="project.defaultPermission == 'create' ? 'mdi-checkbox-marked-outline has-text-primary' : 'mdi-checkbox-blank-outline has-text-black'" />
                        </span>
                    </div>
                    <div class="columns is-mobile is-multiline  pt-3 mb-0 mr-0">
                        <div class="column pb-0">
                            <p class="check-title is-size-6 primary-font has-text-black">
                                {{ $t('registered_users_can_add_content') }}
                            </p>
                        </div>
                    </div>
                </div>-->
                <div class="notification limit-message secondary-font mt-2" v-if="privacyMessage" v-html="$t('cannot_change_project_perms')" />
            </div>
        </div>

        <div v-if="isProject && project.privacy == 'secret'" class="pb-3">
            <div class="">
                <label v-t="'view_project_url'" class="label primary-font has-text-black"></label>
                <div class="field has-addons shareUrl">
                    <p class="control is-expanded mb-0">
                        <input :value="shareURL" readonly class="input is-6" type="text" />
                    </p>
                    <p class="control">
                        <a
                            :class="{
                                'has-tooltip-active': showCopiedTooltipLink,
                            }"
                            :data-tooltip="
                                $t(
                                    showCopiedTooltipLink
                                        ? 'Sessions.url_copied'
                                        : 'Sessions.copy_url'
                                )
                            "
                            class="button is-disabled has-tooltip-left"
                            @click="copyURLProject"
                        >
                            <span class="icon is-small">
                                <i class="mdi mdi-18px mdi-content-copy"></i>
                            </span>
                        </a>
                    </p>
                    
                </div>
            </div>

            <div class="pt-4" v-if="canShowIframe">
                <label v-t="'project_iframe'" class="label primary-font has-text-black"></label>
                <div class="field has-addons shareIframe">
                    <div class="control is-expanded mb-0">
                        <input :value="shareIframe" readonly class="input is-6" type="text" />
                        
                    </div>
                    <div class="control">
                        <a
                            :class="{
                                'has-tooltip-active': showCopiedTooltipIframe,
                            }"
                            :data-tooltip="
                                $t(
                                    showCopiedTooltipIframe
                                        ? 'Sessions.url_copied'
                                        : 'Sessions.copy_url'
                                )
                            "
                            class="button is-disabled has-tooltip-left"
                            @click="copyIframe"
                        >
                            <span class="icon is-small">
                                <i class="mdi mdi-18px mdi-content-copy"></i>
                            </span>
                        </a>
                    </div>
                </div>
            </div>

        </div>
        <!--<div class="pt-4" v-if="canPublishToLibrary">
            <p class="is-size-5 primary-font pt-2">{{ $t('public_access') }}</p>
            <div class="pb-2 pt-2">
                <div class="columns is-mobile pt-2 mb-0 pr-0">
                    <div class="column is-narrow">
                        <span class="icon is-medium is-clickable" @click="changePrivacy('public')">
                            <i class="mdi mdi-32px"
                                :class="project.privacy == 'public' ? 'mdi-checkbox-marked-outline has-text-primary' : 'mdi-checkbox-blank-outline has-text-black'" />
                        </span>
                    </div>

                    <div class="columns is-mobile is-multiline pt-3 mb-0 mr-0">
                        <div class="column pb-0">
                            <p class="check-title is-size-6 primary-font has-text-black">{{
                                $t('publish_in_library') }}</p>
                            <p class="check-subtitle is-size-7 secondary-font has-text-black">
                                {{ $t('projectConfiguration.privacy_public_description') }}</p>

                        </div>
                        <div class="column is-narrow pl-2 pb-0" v-if="canAddAnonymous">
                            <div class="project-permissions">
                                <div class="select pt-1" :class="{ 'disabled': !isPublic }">
                                    <select @change="setProjectPermissionsPublic" class="member-permissions"
                                        :disabled="!isPublic" :class="{ 'disabled': !isPublic }">
                                        <option v-for="permission in permissionOptions" :key="permission"
                                            :value="permission" :selected="projectPerm == permission">
                                            {{
                                                $t(
                                                    `permission_${permission}`
                                                )
                                            }}
                                        </option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div class="column is-narrow pl-2 pb-0" v-else>
                            <div class="project-permissions">
                                <div class="select pt-1" :class="{ 'disabled': !isPublic }">
                                    <select @change="setProjectPermissionsPublic" class="member-permissions"
                                        :disabled="!isPublic" :class="{ 'disabled': !isPublic }">
                                        <option v-for="permission in permissionLimitedOptions" :key="permission"
                                            :value="permission" :selected="projectPerm == permission">
                                            {{
                                                $t(
                                                    `permission_${permission}`
                                                )
                                            }}
                                        </option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div class="column is-12 pl-3 pt-1" :class="{ 'hidden': !isPublic }">
                            <p class="is-size-7 has-text-eduloc-red secondary-font">{{
                                $t(`project_description_level_${projectPerm}`) }}</p>
                        </div>

                    </div>

                </div>
            </div>
        </div>-->

        
        <div class="pt-4" v-if="isProject && canPublishToApp">
            <!--<div class="pb-2">
                <div class="columns is-mobile pt-2 mb-0 pr-0">
                    <div class="column is-narrow">
                        <span class="icon is-medium is-clickable" @click="toggleAppAvailability()">
                            <i class="mdi mdi-32px"
                                :class="isPublishedApp ? 'mdi-checkbox-marked-outline has-text-primary' : 'mdi-checkbox-blank-outline has-text-black'" />
                        </span>
                    </div>

                    <div class="columns is-mobile is-multiline pt-3 mb-0 mr-0">
                        <div class="column pb-0">
                            <p class="check-title is-size-6 primary-font has-text-black">{{
                                $t('publish_in_app') }}</p>
                            <p class="check-subtitle is-size-7 secondary-font has-text-black">
                                {{ $t('publish_in_app_description') }}</p>

                        </div>
                    </div>
                </div>
            </div>-->

            

            <div class="columns is-mobile pt-2" v-if="isPublishedApp && isProject">
                <div class="column is-4 is-narrow has-text-centered" >
                    <figure class="image is-square mt-2">
                        <vue-qrcode ref="qrcode" :value="qrInfo" :margin="0"/>
                    </figure>
                    <div class="pt-2">
                        <p class="has-text-eduloc-red is-size-3 beton-font">{{ project.shortCode }}</p>
                        <p class="has-text-black is-size-7 primary-font">{{$t('project_short_code')}}</p>
                    </div>
                </div>
                <div class="column">
                    <div class="">
                        <p class="has-text-black is-size-6 primary-font mb-2">{{$t('get_app')}}</p>
                    </div>
                    <div class="columns is-mobile mb-0">
                        <div class="column is-6 is-narrow">
                            <figure class="image is-square">
                                <img src="@/assets/images/eduloc360.png">
                            </figure>
                        </div>
                        <div class="column">
                            <div v-if="$i18n.locale=='ca-ES'">
                                <img
                                    src="@/assets/images/google-play-badge_ca-ES.png"
                                    alt="googlePlay"
                                    width="150"
                                    class=""
                                />
                                <img
                                    src="@/assets/images/appstore_ca-ES.svg"
                                    alt="appStore"
                                    width="150"
                                    class=""
                                />
                            </div>
                            <div v-else-if="$i18n.locale=='es'">
                            
                                <img
                                    src="@/assets/images/google-play-badge_es.png"
                                    alt="googlePlay"
                                    width="150"
                                    class=""
                                />
                            
                                <img
                                    src="@/assets/images/appstore_es.svg"
                                    alt="appStore"
                                    width="150"
                                    class=""
                                />
                            
                            </div>
                            <div v-else>
                                <img
                                    src="@/assets/images/google-play-badge_en.png"
                                    alt="googlePlay"
                                    width="150"
                                    class=""
                                />
                                <img
                                    src="@/assets/images/appstore_en.svg"
                                    alt="appStore"
                                    width="150"
                                    class=""
                                />
                            </div>
                            
                        </div>
                        
                    </div>
                    <div class="pt-1">
                        <p class="has-text-grey-eduloc is-size-7 secondary-font is-italic">{{$t('google_attribution')}}</p>
                        <p class="has-text-grey-eduloc is-size-7 secondary-font is-italic">{{$t('apple_attribution')}}</p>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import { PRIVACY_OPTIONS } from '@/lib/constants';
import ProjectConfigurationPeople from '@/components/ProjectConfigurationPeople';
import { inviteToProject } from '@/services/API';
import VueQrcode from 'vue-qrcode';
import Swal from 'sweetalert2';

export default {
    components: {
        ProjectConfigurationPeople,
        VueQrcode
    },
    model: {
        prop: 'project',
    },
    props: {
        project: {
            type: Object,
            default: () => {
                return {};
            },
        },
    },
    data() {
        return {
            globalPrivacyOptions: PRIVACY_OPTIONS,
            /*schoolPrivacyOptions: SCHOOL_PRIVACY_OPTIONS,*/ //LBY2-147
            //permissionOptions: ['READ', 'CREATE', 'ANONYMOUS'],
            permissionOptions: ['READ', 'CREATE'],
            permissionLimitedOptions: ['READ', 'CREATE'],
            allowAnonymous: this.project.allowAnonymous | false,
            inPrivacy: true,
            inParticipants: false,
            showCopiedTooltipLink: false,
            showCopiedTooltipIframe: false,
            isPublishedApp: this.project.appPublished | false,
            privacyMessage: false,
            baseURL: process.env.VUE_APP_WWW_URL
        };
    },
    computed: {
        canAddUsers() {
            // console.log(this.$store.getters.activePlan.configuration.project.canAddUsers)
            return this.$store.getters.activePlan ? this.$store.getters.activePlan.configuration.project.canAddUsers : false  
        },
        canPublishToApp() {
            return this.$store.getters.activePlan ? this.$store.getters.activePlan.configuration.project.canPublishToApp : false  
        },
        canPublishToLibrary() {
            return this.$store.getters.activePlan ? this.$store.getters.activePlan.configuration.project.canPublishToLibrary : false  
        },
        canAddAnonymous() {
            return this.$store.getters.activePlan ? this.$store.getters.activePlan.configuration.project.canAddAnonymous : false  
        },
        canShowIframe() {
            return this.$store.getters.activePlan ? this.$store.getters.activePlan.configuration.project.showEmbed : false  
        },
        isProject(){
            return this.project.format=="PROJECT_TYPE_MAP" || this.project.format=="PROJECT_TYPE_WALL"
        },
        privacyOptions() {
            /*if (this.$store.getters.hasSchool) { //LBY2-147
                return this.schoolPrivacyOptions; 
            }*/
            return this.globalPrivacyOptions;
        },
        canAllowAnonymous() {
            return (
                this.project.privacy == 'secret' ||
                this.project.privacy == 'public'
            );
        },
        projectPerm() {
            if (this.project.allowAnonymous == true) {
                return "ANONYMOUS";
            } else {
                return this.project.defaultPermission.toUpperCase();
            }
        },
        isSecret() {
            return this.project.privacy == "secret";
        },
        isPublic() {
            return this.project.privacy == "public";
        },
        shareProjectURL() {
            return (process.env.VUE_APP_SHARE_PROJECT_URL + this.project._id);
        },
        shareURL(){
            if(this.project.format=="PROJECT_TYPE_MAP" || this.project.format=="PROJECT_TYPE_WALL"){
                return (process.env.VUE_APP_SHARE_PROJECT_URL + this.project._id + '/view');
            }else{
                return (process.env.VUE_APP_SHARE_PROJECT_URL + this.project._id);
            }
            
        },
        shareIframe() {
            return (
                '<iframe width="100%" height="600px" src="' +
                this.shareEmbedURL +
                '"></iframe>'
            );
        },
        shareEmbedURL() {
            let url = process.env.VUE_APP_SHARE_EMBED_ROOT_URL;
            if(this.project.format=="PROJECT_TYPE_MAP" || this.project.format=="PROJECT_TYPE_WALL"){
                return (process.env.VUE_APP_SHARE_PROJECT_URL + this.project._id + '/view');
            }
            return url + this.project._id;
        },
        qrInfo() {
            return encodeURI(this.baseURL + '/goapp.html?code=' + this.project.shortCode);   
            // return this.project.shortCode;
        },
    },

    methods: {
        resendInvitation(member) {
            // console.log('resendreuqest', member);
            inviteToProject(this.project._id, [member]);
        },
        iconForPermission: function (privacy) {
            switch (privacy) {
                case 'read':
                    return 'mdi mdi-48px  mdi-glasses ';
                case 'create':
                    return 'mdi mdi-48px  mdi-plus';
                case 'edit':
                    return 'mdi mdi-48px  mdi-pencil';
                case 'administrator':
                    return 'mdi mdi-48px  mdi-cog';
            }
        },
        setAllowAnonymous(e) {
            this.project.allowAnonymous = e.target.checked;
        },
        changePrivacy(privacy) {
            // console.log(privacy,this.project.privacy,this.project.appPublished)
            /*if (privacy == "secret" && this.project.appPublished) {
                this.project.appPublished = false;
                this.isPublishedApp = false;
            }*/
            if (this.project.privacy == privacy) {
                this.project.privacy = "private";
                this.project.allowAnonymous = false;
                this.project.defaultPermission = "read"
                this.project.appPublished = false;
                this.isPublishedApp = false;
            } else {
                this.project.privacy = privacy;
                if (this.project.privacy == 'secret') {
                    this.isPublishedApp = true;
                    this.project.appPublished = true;
                    this.project.allowAnonymous = false;
                    this.project.defaultPermission = "read"
                    if (this.$store.getters.hasSchool && this.isPublishedApp) { 
                        Swal.fire({
                            title: this.$t('publish_on_entity_list'),
                            text: this.$t('publish_on_entity_list_description'),
                            showCancelButton: false,
                            confirmButtonText: this.$t('Buttons.close'),
                        }).then((result) => {
                            
                        });
                    }
                }

            }

        },
        setAllUsersPermision() {
            this.project.allowAnonymous = false;
            if (this.project.defaultPermission == "create") {
                this.project.defaultPermission = "read"
            } else {
                console.log("publish to app")
                this.project.defaultPermission = "create";
            }     
        },
        setProjectPermissions(e) {
            // console.log(e.target.value)
            //this.projectPerm = e.target.value;
            switch (e.target.value) {
                case 'READ':
                    this.project.allowAnonymous = false;
                    this.project.defaultPermission = "read"
                    break;
                case 'CREATE':
                    this.project.allowAnonymous = false;
                    this.project.defaultPermission = "create"
                    break;
                case 'ANONYMOUS':
                    this.project.allowAnonymous = true;
                    this.project.defaultPermission = "create"
                    break;
            }
        },
        setProjectPermissionsSecret(e) {
            switch (e.target.value) {
                case 'READ':
                    this.project.allowAnonymous = false;
                    this.project.defaultPermission = "read"
                    break;
                case 'CREATE':
                    this.project.allowAnonymous = false;
                    this.project.defaultPermission = "create"
                    break;
                case 'ANONYMOUS':
                    this.project.allowAnonymous = true;
                    this.project.defaultPermission = "create"
                    break;
            }
        },
        setProjectPermissionsPublic(e) {
            switch (e.target.value) {
                case 'READ':
                    this.project.allowAnonymous = false;
                    this.project.defaultPermission = "read"
                    break;
                case 'CREATE':
                    this.project.allowAnonymous = false;
                    this.project.defaultPermission = "create"
                    break;
                case 'ANONYMOUS':
                    this.project.allowAnonymous = true;
                    this.project.defaultPermission = "create"
                    break;
            }
        },
        toggleAppAvailability(){
            //console.log("checking",this.$store.getters.hasSchool)
            this.isPublishedApp = !this.isPublishedApp;
            this.project.appPublished = this.isPublishedApp;

            if (this.project.appPublished && this.project.privacy != "secret") {
                this.project.privacy = "secret";
            }

            if (this.$store.getters.hasSchool && this.isPublishedApp) { 
                Swal.fire({
                    title: this.$t('publish_on_entity_list'),
                    text: this.$t('publish_on_entity_list_description'),
                    showCancelButton: false,
                    confirmButtonText: this.$t('Buttons.close'),
                }).then((result) => {
                    
                });
            }

            
        },
        copyURLProject() {
            this.$copyText(this.shareProjectURL).then((e) => {
                this.showCopiedTooltipLink = true;
                setTimeout(() => {
                    this.showCopiedTooltipLink = false;
                }, 1500);
            });
        },
        copyIframe() {
            this.$copyText(this.shareIframe).then((e) => {
                this.showCopiedTooltipIframe = true;
                setTimeout(() => {
                    this.showCopiedTooltipIframe = false;
                }, 1500);
            });
        },
        showPrivacyMessage() {
            this.privacyMessage = true;
        },
        hidePrivacyMessage() {
            this.privacyMessage = false;
        },
        togglePrivacyMessage() {
            this.privacyMessage = !this.privacyMessage;
        },
    },
};
</script>

<style scoped>
.lb-project-privacy-option {
    height: 5.5rem;
    width: 6.5rem;
    border: none;
}

.check-title {
    margin-top: -2px;
}


.lh-12 {
    line-height: 1.2rem;
}

.project-permissions .member-permissions {
    border-radius: 0;
    padding-top: 0;
    padding-bottom: 0;
    height: 2.3rem;
    background-color: var(--eduloc-grey-background);
    border: 1px solid black;
    padding-right: 1.5rem
}

.project-permissions .member-permissions:hover {
    border: 1px solid black;
}

.project-permissions .select:not(.is-multiple):not(.is-loading)::after {
    top: 19px;
    right: 0.5rem
}

.column.hidden {
    display: none;
}

.project-permissions select.disabled {
    border: 1px solid var(--eduloc-grey-background);
}

.project-permissions .select.disabled::after {
    border-color: var(--eduloc-grey);

}

.project-permissions .member-permissions.disabled {
    border: 1px solid var(--eduloc-grey);
}

.project-permissions .member-permissions.disabled:hover {
    border: 1px solid var(--eduloc-grey);
}

.check-subtitle {
    line-height: 0.9rem;
}

.has-scroll-y{
    max-height: calc(100vh - 13rem);
    height: calc(100vh - 13rem);
}

.limit-message{
    position: relative;
    background-color: #000000;
    color: #FFFFFF;
    text-align: left;
    opacity: 0.8;
}
</style>
